<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        style="width: 100px"
        size="small"
        clearable
      >
        <el-option value="未提交">未提交</el-option>
        <el-option value="已提交">已提交</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="退货单号"
        size="small"
        style="width: 150px"
        clearable
      />
      <el-input
        v-model="query.orderBillNo"
        placeholder="订单编号"
        size="small"
        style="width: 150px"
        clearable
      />
      <el-input
        v-model="query.fCkBillNo"
        placeholder="发货单号"
        size="small"
        style="width: 150px"
        clearable
      />
      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fCustomer"
        placeholder="客户"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        type="success"
        size="small"
        :loading="auditing"
        @click="_audit"
      >批量确认<span v-if="auditing">中...</span></el-button>
      <el-button-export :url="downloadUrl" type="primary" size="small">导出</el-button-export>
      <span v-if="monnyNum" style="margin:0 0 0 10px">金额：{{ monnyNum }}</span>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table v-loading="loading" v-el-table-height-fix :data="tableData" height="100%" @row-dblclick="_view" @select="rowSelect" @select-all="rowSelect">
        <el-table-column type="selection" width="50" />
        <el-table-column prop="fBillNo" label="退货单号" width="155" />
        <el-table-column prop="fOrderBillNo" label="订单编号" width="140" />
        <el-table-column prop="fCkBillNo" label="送货单号" width="130" />
        <el-table-column prop="fDistributor" label="经销商" min-width="220" />
        <el-table-column prop="fCustomer" label="客户名称" min-width="170" />
        <el-table-column prop="fAmount" label="总金额" min-width="60" />
        <el-table-column prop="fDes" label="退货原因" width="100" />
        <el-table-column prop="fDate" label="退货日期" width="100" />
        <el-table-column prop="fState" label="状态" width="80" />
        <el-table-column label="操作" class-name="table-oper-col" width="90">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
            <template>
              <ConfirmButton v-if="scope.row.fState == '已审核'" @confirm="_unaudit(scope.row)">反审</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'
import DealResults from './DealResults'

export default {
  components: {
    ConfirmButton,
    DealResults
  },
  data() {
    return {
      query: {
        fState: '未提交',

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      auditing: false,
      currentEditItems: null,
      monnyNum: 0
    }
  },
  mounted() {

  },
  activated() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('SaleRetrun/SaleRetrunBillForCwq/SaleRetrunBillForCwqEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _view: async function(row) {
      const readonly = await this.$httpPost('OrderManage/GetBillState', {
        fid: row.fid,
        key: 'ReturnGoods_cw_q'
      }).then(res => res.datalist)
      var url = this.$route.path + '/' + (readonly ? 'v/' : '') + row.fid
      this.$router.push(url)
    },
    _unaudit: function(row) {
      this.loading = true
      this.$httpPost('SaleRetrun/SaleRetrunBillForCwq/SaleRetrunUnApproval', { fid: row.fid }).then(res => {
        if (!res.isSuccess) {
          this.loading = false
          this.$message.error(res.message)
          return
        }
        this.$message.success(res.message)
        this.refresh()
      })
    },
    rowSelect: function(selction) {
      this.currentEditItems = selction
      let num = 0
      selction.forEach(val => {
        num += val.fAmount
      })
      const nums = num.toFixed(2)
      nums == 0.00 ? this.monnyNum = num : this.monnyNum = nums
    },
    _audit: function() {
      this.auditing = true
      this.postData(1, '确认').finally(() => {
        this.auditing = false
      })
    },
    postData: async function(type, msg) {
      const items = this.currentEditItems

      if (!items || !items.length) {
        this.$message.warning('请选中要操作的行')
        return
      }

      const confirmOK = await this.confirm(`是否${msg}所选行`)
      if (!confirmOK) return

      return this.$httpPost(`SaleRetrun/SaleRetrunBillForCwq/SaleRetrunBatch`, {
        datalist: JSON.stringify({
          modifyType: type,
          idList: items.map((x) => x.fid)
        })
      }).then((res) => {
        if (res.isSuccess) {
          if (res.datalist.failTotal > 0) {
            const h = this.$createElement
            this.$formDlg({
              title: `处理结果`,
              width: '30%',
              readonly: true,
              formTpl: (
                <DealResults form={res.datalist.failMessages}></DealResults>
              )
            })
          } else {
            this.$message.success(res.message)
          }
          this.currentEditItems = []
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/SaleRetrunCwqDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }
  }
}
</script>
